import { module } from 'stereomodularjs';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        let thumbnails = this.el.querySelectorAll('.js-thumb-select');
        let bgs = this.el.querySelectorAll('.js-bg-img');

        thumbnails.forEach((thumb, index) => {
            eventAdd(thumb, 'click', () => {
                // Remove active class from thumbnails items
                thumbnails.forEach (nodeThumb => {
                    nodeThumb.classList.remove('is-active');
                });

                // Add active class on selected thumbnail
                thumb.classList.add('is-active');

                // Remove active class from bg images items
                bgs.forEach (nodeBg => {
                    nodeBg.classList.remove('is-active');
                });

                // Add active class on bg item (index is based on thumbnail click)
                bgs[index].classList.add('is-active');
            });
        });
    }
}
